import { render, staticRenderFns } from "./WarehouseManagementTablePage.vue?vue&type=template&id=979ce6ee"
import script from "./WarehouseManagementTablePage.vue?vue&type=script&lang=js"
export * from "./WarehouseManagementTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports